import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class CopyrightComponent {
  @Input() copyright: string = '';

  readonly defaultCopyRight = `© ${new Date().getFullYear()} Connecture, Inc. All rights reserved.`;
}
